import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./product-card.module.scss";

function ProductCard(props) {
  const {
    content: {
      view,
      viewTitle,
      path,
      product,
      title,
      price,
      price: {basePrice, currentPrice}
    },
    className,
    size
  } = props;
  const hasDiscount = currentPrice < basePrice;
  return (
    <div className={classNames(styles.root, styles[`${size}Root`], className)}>
      {view && (
        <a href={path} className={styles.viewWrap}>
          <img
            src={view}
            title={viewTitle}
            alt={product || title || `Изображение продукта`}
            className={styles.view}
          />
        </a>
      )}
      <div className={styles.footer}>
        {product && (
          <a href={path} className={styles.product}>
            {product}
          </a>
        )}
        {title && (
          <a href={path} className={styles.title}>
            {title}
          </a>
        )}
        {price && (
          <div className={styles.price}>
            {hasDiscount && <div className={styles.basePrice}>{basePrice}</div>}
            <div className={styles.currentPrice}>{currentPrice}₽</div>
          </div>
        )}
      </div>
    </div>
  );
}

ProductCard.defaultProps = {
  size: `small`
};

ProductCard.propTypes = {
  content: PropTypes.shape({
    product: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.object,
    view: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([`small`, `tile`, `teaser`])
};

export default ProductCard;
